export { InsightsHeading } from './InsightsHeading';
